/**
 * The fixed palette (design handoff, ADR 0023): the single source for colour.
 * The app root copies it into `--p-*` custom properties and `tokens.css` maps
 * those to utilities; glass and line alphas are mixed from these in CSS.
 * `danger` is one step darker than the handoff's #ef4444 so white text on the
 * "away" pill reads at 4.5:1.
 */
export const PALETTE = {
    ground: "#000000",
    ink: "#ffffff",
    glass: "#0a0c10",
    gold: "#fde68a",
    goldDeep: "#d97706",
    goldInk: "#3a2600",
    green: "#86efac",
    greenDeep: "#15803d",
    greenInk: "#052e16",
    success: "#34d399",
    danger: "#dc2626",
    dangerSoft: "#f87171",
    slate: "#64748b",
    crown: "#d4af37",
    /* The leaderboard's medals (design): gold, silver and bronze, each with its ring's dark end. */
    goldDark: "#b8860b",
    silver: "#e2e8f0",
    bronze: "#f6ad7b",
    bronzeDark: "#9a5b2a",
    lobbyTop: "#1b1f3a",
    lobbyMid: "#0b0d1c",
    violet: "#7c3aed",
    sky: "#0ea5e9",
    suitRed: "#ff6b6b",
    suitSteel: "#94a3b8",
    card: "#ffffff",
    cardEdge: "#d8d8d0",
    cardBlack: "#111111",
    cardRed: "#c1121f",
};
/** Text on fill: every pair the screens use must reach 4.5:1 (WCAG 1.4.3; tested). */
export const TEXT_ON_FILL = [
    ["goldInk", "gold"],
    ["goldInk", "goldDeep"],
    ["greenInk", "green"],
    ["ink", "glass"],
    ["gold", "glass"],
    ["silver", "glass"],
    ["bronze", "glass"],
    ["success", "glass"],
    ["dangerSoft", "glass"],
    ["ink", "danger"],
    ["cardBlack", "card"],
    ["cardRed", "card"],
];
/** The palette as `--p-gold-deep: #d97706` pairs, for the app root. */
export function paletteVars() {
    const vars = {};
    for (const [name, hex] of Object.entries(PALETTE))
        vars[`--p-${name.replace(/[A-Z]/g, (c) => `-${c.toLowerCase()}`)}`] = hex;
    return vars;
}
//# sourceMappingURL=palette.js.map